var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-item', {
    attrs: {
      "to": "/roomobject/".concat(_vm.item.m_DBAccessID)
    }
  }, [_vm.collection ? [_c('v-list-item-avatar', {
    attrs: {
      "size": 48
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.roomobjecticon.format(_vm.categoryName, _vm.item.m_ID) + '.jpg'
    }
  })], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.item.m_Name))])], 1)] : [_c('v-list-item-avatar', {
    staticClass: "mx-auto mr-2 mr-md-4",
    attrs: {
      "size": _vm.$size()
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.roomobjecticon.format(_vm.categoryName, _vm.item.m_ID) + '.jpg'
    }
  })], 1), _c('v-list-item-content', {
    staticClass: "mr-auto ml-0"
  }, [_c('v-list-item-title', {
    staticClass: "d-flex align-center"
  }, [_vm._v(_vm._s(_vm.item.m_Name)), _c('v-list-item-subtitle', {
    staticClass: "pl-1 hidden-sm-and-up"
  }, [_c('span', [_vm._v(_vm._s(_vm.item.m_SizeX) + "×" + _vm._s(_vm.item.m_SizeY))])])], 1), _c('v-list-item-subtitle', [_c('span', [_vm._v(_vm._s(_vm.filterString(_vm.item.m_FilterName)))]), _c('span', {
    staticClass: "float-right hidden-sm-and-up"
  }, [_vm._v(_vm._s(_vm.item.m_BuyAmount))])]), _c('v-list-item-subtitle', {
    staticClass: "hidden-xs-only"
  }, [_c('span', [_vm._v(_vm._s(_vm.item.m_SizeX) + "×" + _vm._s(_vm.item.m_SizeY))]), _c('span', {
    staticClass: "float-right"
  }, [_vm._v(_vm._s(_vm.item.m_BuyAmount))])])], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }